import { matchPath as defaultMatchPath } from 'react-router'

import { RouteKey } from '@routes'

const matchPath = (pathname: string, path: string) => {
  return defaultMatchPath(pathname, { path: `/${path}`, exact: false })
}

export const isActiveRoute = (pathname: string, route: RouteKey) => {
  // We need to do this because the "bookings" header navigation item is defined on the "fastTapeChart" route.
  const formattedRoute: RouteKey = route === 'fastTapeChart' ? 'bookings' : route

  // Hotel pages must be under the "Buildings" navigation section.
  if (route === 'buildings' && matchPath(pathname, 'hotels')) {
    return true
  }

  if (route === 'fastTapeChart' && matchPath(pathname, 'groups-events')) {
    return true
  }

  return !!matchPath(pathname, formattedRoute)
}
